import PrimaryMenu from "./Pages/PrimaryMenu/PrimaryMenu";

const menu = new PrimaryMenu();
menu.pages();
